import { motion } from "framer-motion";

const TEAM = [
  { name: "Azalea De Jager", role: "Practice Manager", qual: "BSc Physiotherapy (UWC)", img: "/team-azalea.jpg", imgPos: "object-center" },
  { name: "Megan Santon", role: "Financial Manager", qual: "BSc Physiotherapy (UWC)", img: "/team-megan.jpg", imgPos: "object-center" },
  { name: "Katherine Sedres", role: "Marketing & Communications Manager", qual: "BSc Physiotherapy (UWC)", img: "/team-katherine.jpg", imgPos: "object-center" },
  { name: "Ilham Simon", role: "Patient Services Manager", qual: "BSc Physiotherapy (UWC)", img: "/team-ilham.jpg", imgPos: "object-center" },
  { name: "Nizaamud-Deen Sylvester", role: "Clinical & Quality Manager", qual: "BSc Physiotherapy (UWC)", img: "/team-nizaamuddeen.jpg", imgPos: "object-center" },
];

const Silhouette = () => (
  <svg viewBox="0 0 200 220" className="w-full h-full" aria-hidden="true">
    <defs>
      <linearGradient id="silbg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#dcebff" />
        <stop offset="100%" stopColor="#a9ccff" />
      </linearGradient>
    </defs>
    <rect width="200" height="220" fill="url(#silbg)" />
    <circle cx="100" cy="82" r="38" fill="#001a4d" opacity="0.35" />
    <path d="M28 220 C28 162 66 142 100 142 C134 142 172 162 172 220 Z" fill="#001a4d" opacity="0.35" />
  </svg>
);

export const Team = () => (
  <section id="team" data-testid="team-section" className="bg-gradient-to-b from-[#eaf3ff] via-mist to-mist py-28 lg:py-40">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16 lg:mb-20">
        <div>
          <p className="text-xs font-bold tracking-[0.3em] uppercase text-electric mb-6">Meet The Team</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-ink leading-[0.95]">
            Five physiotherapists.<br />One point of care.
          </h2>
        </div>
        <p className="max-w-sm text-neutral-500 text-sm lg:text-base leading-relaxed">
          The founding team behind FivePoint — UWC-qualified physiotherapists, each leading a
          pillar of the practice.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-5">
        {TEAM.map((m, i) => (
          <motion.div
            key={m.name}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ delay: i * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -8 }}
            className="group"
            data-testid={`team-card-${i}`}
          >
            <div className="relative overflow-hidden rounded-lg aspect-[200/220] mb-5 border border-black/10">
              {m.img ? (
                <img
                  src={m.img}
                  alt={`${m.name} — ${m.role}`}
                  loading="lazy"
                  className={`w-full h-full object-cover ${m.imgPos || "object-center"} transition-transform duration-700 group-hover:scale-105`}
                  data-testid={`team-photo-${i}`}
                />
              ) : (
                <>
                  <Silhouette />
                  <span className="absolute bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-navy/85 backdrop-blur px-3 py-1 text-[9px] font-semibold tracking-[0.2em] uppercase text-white">
                    Photo coming soon
                  </span>
                </>
              )}
            </div>
            <h3 className="font-display font-bold text-base lg:text-lg text-ink tracking-tight leading-tight">{m.name}</h3>
            <p className="text-electric text-xs font-semibold mt-1">{m.role}</p>
            <p className="text-neutral-400 text-xs mt-1">{m.qual}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
